<template>
<div>
	<h2>Please wait... </h2>
</div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'userTour',
  props: ['dashboardName'],
  components: {
  },
  data: () => {
    return {
    }
  },

  mounted () {
    this.loadUserTour()
  },

  methods: {
    ...mapActions([
      'loadLogDashboardActivity'
    ]),

    loadUserTour () {
      // log login activity
      this.loadLogDashboardActivity({action: 'tour', page: 'tour', link: ''})
      // redirect to dashboard
      return this.$router.push({name: this.dashboardName, params: { forceShowTour: true }})
    }
  },

  computed: {
  },

  watch: {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/app/user/components/UserTour.vue